import { Deserializable } from '../interfaces';

export class PlanUser implements Deserializable {
  descripcion: string | null;
  estatusPaquete: number | null;
  idPaquete: number | null;
  mensualidad: number | null;
  seleccionado: string | null;
  servicios: string | null;

  constructor() {
    this.descripcion = null;
    this.estatusPaquete = null;
    this.idPaquete = null;
    this.mensualidad = null;
    this.seleccionado = null;
    this.servicios = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
